import React from 'react';
import ProjectEffort from './ProjectEffort';

const EDRProjectEffortMain = () => (
  <>
    {/* Main Table */}
    <ProjectEffort />
  </>
);

export default EDRProjectEffortMain;
